import request from '@/utils/request';

export function getKEVRCategoriesAsKeyValuePairList() {
  return request({
    url: '/api/kevrcategory/GetKEVRCategoriesAsKeyValuePairList',
    method: 'get',
  });
}
